import Route from '@ember/routing/route';

export default class AuthenticatedPslfDashboardForgivenessEstimatorResultsIndexRoute extends Route {
  model() {
    return this.modelFor('authenticated.idr.dashboard.forgiveness-estimator.results');
  }
}
